import { Divider } from 'antd';
import { Plugins } from '@capacitor/core';
import { Fragment, useEffect, useState } from 'react';
import { groupBy, isArray, isPlainObject, mapValues, reduce, toPairs } from 'lodash';
import { LoremIpsum } from "lorem-ipsum";
import JSONPretty from 'react-json-pretty';
import JSONTheme from 'react-json-pretty/dist/monikai';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

const { Storage } = Plugins;



// OBJECTS
export const nest = function (seq, keys) {
    if (!keys.length)
        return seq;
    var first = keys[0];
    var rest = keys.slice(1);
    return mapValues(groupBy(seq, first), function (value) {
        return nest(value, rest)
    });
};




// MATH
export const percentOf = (num1, num2) => Math.round(((num1 / num2) * 100) * 10) / 10;

// DATES

export const randomDate = (start, end) => {
    var d = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
};

export const dateObjFormatter = (date, separator = '/') => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [day, month, year].join(separator);
};

export const compareDates = (a,b) => {
    // no date is less
    if(!a) return -1;
    if(!b) return 1;
    const A = dayjs(a);
    const B = dayjs(b);

    return A.diff(B);
}

export const momentToDate = date => {
    if (!date) { return new Date() };
    return new Date(date)
};





// FILES
export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const bytesToSize = bytes => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
};




// DEVICE
export const useIsMobile = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => setWidth(window.innerWidth);
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    return width <= 768;
};




// DEBUG
export const JSONDebug = ({ data, active }) => {
    if (!active) { return null };
    return (
        <Fragment>
            <Divider />
            <JSONPretty theme={JSONTheme}
                id="json-pretty" data={data || {}} />
        </Fragment>
    )
};




// FORM
const handleInitDataTypes = data => {
    if (isPlainObject(data) && data?.id) { return data?.id };
    if (isPlainObject(data) && !data?.id) { return data };
    if (isArray(data)) {
        const output = reduce(data, (acc, curr) => {
            const current = { ...curr }
            for (let prop in current) {
                if (isPlainObject(current[prop])) {
                    current[prop] = current[prop]?.id;
                }
            };
            acc.push(current);
            return acc;
        }, []);
        return output;
    }
    return data;
};

export const formatFormInitialData = data => {
    const fields = toPairs(data).reduce((flds, a) => {
        flds.push({ name: a[0], value: handleInitDataTypes(a[1]) });
        return flds;
    }, []);
    return fields;
};





// MOCK
export const mockedText = (textLenght = 1) => {
    const text = new LoremIpsum({
        sentencesPerParagraph: {
            max: 8,
            min: 4
        },
        wordsPerSentence: {
            max: 16,
            min: 4
        }
    });
    return text.generateSentences(textLenght)
};

export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});




// COOKIES
export const setCookie = async (key, value, exdays) => {
    await Storage.set({ key, value: JSON.stringify(value) });
};

export const getCookie = async (key) => {
    const c = await Storage.get({ key: key })
    return JSON.parse(c.value);
};

export const deleteCookie = async (key) => {
    await Storage.remove({ key })
};


// export const setCookie = (cname, cvalue, exdays) => {
//     var d = new Date();
//     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//     var expires = "expires=" + d.toUTCString();
//     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// };

// export const getCookie = (cname) => {
//     var name = cname + "=";
//     var decodedCookie = decodeURIComponent(document.cookie);
//     var ca = decodedCookie.split(';');
//     for (var i = 0; i < ca.length; i++) {
//         var c = ca[i];
//         while (c.charAt(0) === ' ') {
//             c = c.substring(1);
//         }
//         if (c.indexOf(name) === 0) {
//             return c.substring(name.length, c.length);
//         }
//     }
//     return "";
// };

// export const deleteCookie = (cname) => {
//     document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
// };